import React from 'react';
import { UnAuthorizedLayout } from '../Layouts/UnAuthorizedLayout';
import { Link } from 'react-router-dom';

const UserSignUp = () => {

    return (
        <UnAuthorizedLayout>
            <div style={{ textAlign: "center" }}>
                <button onClick={() => {

                }}>
                    SignUp
                </button>
            </div>
            <div className="text-center mt-4">
                    <p className="mb-0" style={{ color: '#7f8c8d', fontSize: '0.9rem' }}>
                        Already have an account?{' '}
                        <Link to="/" className="auth-link">
                            Sign in
                        </Link>
                    </p>
                </div>
        </UnAuthorizedLayout>
    );
};

export default UserSignUp;
